import React, { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addNewCollections } from "../../Redux/Actions/collectionsActions";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const AddCollections = () => {
  const [collectionState, setCollectionState] = useState({
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    image: "",
    icon: "",
    banner_image: "",
    banner_title: "",
    three_d_icon: "",
  });

  const navigate = useNavigate();

  const handleImageUpload = async (event, type) => {
    const file = event.target.files[0];
    if (!file) return;

    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setCollectionState((prevState) => ({ ...prevState, [type]: imageUrl }));
    }
  };

  const dispatch = useDispatch();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await dispatch(addNewCollections(collectionState));
      if (response.statusCode === 200) {
        navigate("/collections");
      }
      setCollectionState({
        name: "",
        position: Math.floor(Math.random() * 1000) + 1,
        image: "",
      });
    } catch (error) {
      console.log(error?.data?.response?.message);
    }
  };

  return (
    <MainLayout>
      <div
        style={{
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          width: "100%",
          padding: "20px",
        }}
      >
        <div className="flex-container flex-justify-between align-center">
          <h1>Add Collection</h1>
          <Link to="/collections">
            <button className="button-class">View Collection List</button>
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex-container flex-justify-between gap-10 align-center">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Colection Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="image"
                accept="image/*"
                name="image"
                onChange={(event) => handleImageUpload(event, "image")}
              />
              <label className="label-class-image" htmlFor="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.image}
                keyField="image"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Colection Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="icon"
                accept="image/*"
                name="icon"
                onChange={(event) => handleImageUpload(event, "icon")}
              />
              <label className="label-class-image" htmlFor="icon">
                Click to Upload Icon
              </label>
              <ImageShowerModalGlobal
                file={collectionState.icon}
                keyField="icon"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container gap-10 flex-center margin-h-10">
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Banner Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="banner_image"
                accept="image/*"
                name="banner_image"
                onChange={(event) => handleImageUpload(event, "banner_image")}
              />
              <label className="label-class-image" htmlFor="banner_image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.banner_image}
                keyField="banner_image"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload 3D Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="three_d_icon"
                accept="image/*"
                name="three_d_icon"
                onChange={(event) => handleImageUpload(event, "three_d_icon")}
              />
              <label className="label-class-image" htmlFor="three_d_icon">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={collectionState.three_d_icon}
                keyField="three_d_icon"
                setState={setCollectionState}
                state={collectionState}
              ></ImageShowerModalGlobal>
            </div>
          </div>
          <div className="flex-container gap-10 flex-center margin-h-10">
            <div style={{ width: "50%" }}>
              <TextInput
                name="name"
                placeholder="Enter Name"
                value={collectionState.name}
                onChange={(event) =>
                  setCollectionState({
                    ...collectionState,
                    name: event.target.value,
                  })
                }
                label="Collection Name"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                name="banner_title"
                placeholder="Enter Title"
                value={collectionState.banner_title}
                onChange={(event) =>
                  setCollectionState({
                    ...collectionState,
                    banner_title: event.target.value,
                  })
                }
                label="Banner Title"
              ></TextInput>
            </div>
          </div>
          <div className="flex-end" style={{ margin: "20px auto" }}>
            <Link to="/collections">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" type="submit">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCollections;
